/* eslint-disable react/prop-types */
import { StyleProps, styled } from "@shared/primitive-components"
import { useCallback, useState } from "react"
import { FaCogs } from "react-icons/fa"
import { IFrame } from "./iframe"

type StyleElementProps = StyleProps & Readonly<{ open: boolean }>

type PolicyDevToolsProps = Readonly<{
  policyId?: string
}>

// ---------------------------------------------------------------------------------------------------

const PolicyDevToolsWidget = styled.div<StyleElementProps>((props) => ({
  position: `fixed`,
  top: `calc(50% - 40px)`,
  right: props.open ? `350px` : `0px`,
  bottom: `calc(50% - 40px)`,
  width: `25px`,
  height: `80px`,
  background: props.theme.palette.coal.dark,
  color: props.theme.palette.white,
  pointerEvents: `all`,
  transition: `all 0.3s ease-in-out`,
  borderBottomLeftRadius: `10px`,
  borderTopLeftRadius: `10px`,
  cursor: `pointer`,
  display: `flex`,
  flexDirection: `column`,
  alignItems: `center`,
  justifyContent: `center`,
}))

const PolicyDevToolsOverlay = styled.div<StyleElementProps>((props) => ({
  pointerEvents: props.open ? `all` : `none`,
  background: props.open ? `rgba(0, 0, 0, 0.7)` : `rgba(0, 0, 0, 0)`,
  position: `fixed`,
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  width: `100%`,
  transition: `all 0.3s ease-in-out`,
}))

const PolicyDevToolsWrapper = styled.div<StyleElementProps>((props) => ({
  position: `fixed`,
  top: 0,
  right: 0,
  bottom: 0,
  width: props.open ? `350px` : `0px`,
  transition: `all 0.3s ease-in-out`,
}))

// ---------------------------------------------------------------------------------------------------

export const PolicyDevTools: React.FC<PolicyDevToolsProps> = ({ policyId }) => {
  const [open, setIsOpen] = useState(false)

  const toggleMenu = useCallback(() => setIsOpen(!open), [open])

  if (!policyId) return null

  return (
    <>
      {false && (
        <PolicyDevToolsOverlay open={open}>
          <PolicyDevToolsWrapper open={open}>
            <PolicyDevToolsWidget open={open} onClick={toggleMenu}>
              <FaCogs />
            </PolicyDevToolsWidget>
            <IFrame path={`policies/${policyId}/tools`} />
          </PolicyDevToolsWrapper>
        </PolicyDevToolsOverlay>
      )}
    </>
  )
}
